import { Directive, ElementRef, OnInit, Renderer2, inject } from '@angular/core';
import { FORM_MAX_LENGTH } from '../constants/form-limits';

/**
 * Applies a default `maxlength` to text inputs and textareas. Import it into a
 * component's `imports` array; no markup changes needed.
 *
 * A field-specific limit always wins: the selector skips elements that declare
 * `maxlength`, and the attribute is written once in `ngOnInit`; any later
 * `[attr.maxlength]` binding (or explicit `maxlength` in markup) can override it.
 */
@Directive({
  selector:
    'input:not([maxlength]):not([type=number]):not([type=date]):not([type=datetime-local])' +
    ':not([type=month]):not([type=week]):not([type=time]):not([type=file]):not([type=checkbox])' +
    ':not([type=radio]):not([type=range]):not([type=color]):not([type=hidden])' +
    ':not([type=submit]):not([type=button]):not([type=reset]),' +
    'textarea:not([maxlength])',
  standalone: true,
})
export class MaxLengthDirective implements OnInit {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);

  ngOnInit(): void {
    const element = this.el.nativeElement;
    if (element.hasAttribute('maxlength')) return;

    const fallback =
      element.tagName === 'TEXTAREA'
        ? FORM_MAX_LENGTH.LARGE
        : FORM_MAX_LENGTH.DEFAULT;

    this.renderer.setAttribute(element, 'maxlength', String(fallback));
  }
}
